module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"new":"Neuen Belegtext anlegen","no-result":"Kein Ergebnis","save":"Speichern","cancel":"Abbrechen","text":"Belegtext","title":"Bezeichnung"},"en":{"new":"Neuen Belegtext anlegen","no-result":"Kein Ergebnis","save":"Speichern","cancel":"Abbrechen","text":"Belegtext","title":"Bezeichnung"}}')
  delete Component.options._Ctor
}
